//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Display.js";
import "../no/Builder.js";
import "../no/ugmath.js";
let d=[[[0,"ApertureType",1,0],[0,"AspectRatioHeight",1,0],[0,"AspectRatioType",1,0],[0,"AspectRatioWidth",1,0],[0,"BackClippingDistance",1,0],[0,"CameraMatrix",1,0],[0,"CameraName",1,0],[0,"CameraNameChar",1,0],[0,"CameraPosition",1,0],[0,"DepthOfFieldToggle",1,0],[0,"FieldOfViewAngle",1,0],[0,"FieldOfViewMeasured",1,0],[0,"FocalDistance",1,0],[0,"FrontClippingDistance",1,0],[0,"HiddenLensFlareToggle",1,0],[0,"LensAngleType",1,0],[0,"LensFlareIntensity",1,0],[0,"LensFlareToggle",1,0],[0,"LensFlareType",1,0],[0,"Magnification",1,0],[0,"PerspectiveDistance",1,0],[0,"StockLensType",1,0],[0,"TargetMatrix",1,0],[0,"TargetPosition",1,0],[0,"Type",1,0],[0,"UseTargetPoint",1,0]],[],[]];
SPLM.Display.CameraBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Display.CameraBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Display.CameraBuilder.Types = Object.freeze({
    "Parallel" : "Parallel", "Perspective" : "Perspective"});

SPLM.Display.CameraBuilder.LensAngle = Object.freeze({
    "Stock" : "Stock", "Fov" : "Fov", "Magnification" : "Magnification"});

SPLM.Display.CameraBuilder.StockLens = Object.freeze({
    "S28" : "S28", "S35" : "S35", "S50" : "S50", "S70" : "S70", "S105" : "S105", "S135" : "S135", "S210" : "S210", "S300" : "S300"});

SPLM.Display.CameraBuilder.FovMeasured = Object.freeze({
    "Horizontally" : "Horizontally", "Vertically" : "Vertically"});

SPLM.Display.CameraBuilder.LensFlare = Object.freeze({
    "Standard" : "Standard", "S35" : "S35", "S50" : "S50", "S105" : "S105", "Polygonal" : "Polygonal", "P35" : "P35", "P50" : "P50", "P105" : "P105", "Spark" : "Spark", "Star" : "Star"});

SPLM.Display.CameraBuilder.Aperture = Object.freeze({
    "F28" : "F28", "F56" : "F56", "F8" : "F8", "F11" : "F11", "F16" : "F16", "F22" : "F22"});

SPLM.Display.CameraBuilder.AspectRatio = Object.freeze({
    "GraphicsWindow" : "GraphicsWindow", "ImageBasedBackground" : "ImageBasedBackground", "SquareFormat" : "SquareFormat", "StandardPhotoPrintFormat" : "StandardPhotoPrintFormat", "StandardVideoFormat" : "StandardVideoFormat", "HdtvFormat" : "HdtvFormat", "UserDefined" : "UserDefined"});

export default SPLM;